import { getDomain } from "./getDomain";

export const getApiUrl = () => {
  const domain = getDomain();

  let apiUrl = process.env.API_URL;

  if (domain === "frontassist.eu") {
    apiUrl = process.env.FRONTASSIST_API_URL;
  }

  return apiUrl;
};
